import { render, staticRenderFns } from "./anchor-nav.vue?vue&type=template&id=e418caf2&scoped=true"
import script from "./anchor-nav.vue?vue&type=script&lang=js"
export * from "./anchor-nav.vue?vue&type=script&lang=js"
import style0 from "./anchor-nav.vue?vue&type=style&index=0&id=e418caf2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e418caf2",
  null
  
)

export default component.exports